import { render, staticRenderFns } from "./ContractPublisherShareForm.vue?vue&type=template&id=68f2a822"
import script from "./ContractPublisherShareForm.vue?vue&type=script&lang=js"
export * from "./ContractPublisherShareForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports